module.exports = function() {
  return new Worker(__webpack_public_path__ + "b7861c46dc4f70086d94.worker.js");
};